import { useMutation } from '@tanstack/react-query';
import api from '../../services/api';

export interface InvoiceData {
    code: number;
    barcode: string;
}

export const useInvoiceFetch = async (invoiceData: InvoiceData) => {
    const response = await api.post<{ link: string }>(
        `erp/invoice-link`,
        invoiceData,
    );
    return response.data;
};

export function useInvoiceMutation() {
    return useMutation({
        mutationFn: (data: InvoiceData) => useInvoiceFetch(data),
        retry: false,
    });
}
